<template>
    <div class="modal-mask scroll-tracker" v-show="isShow">
        <div class="modal-level" v-for="(modal, idx) in modals" :key="idx" :style="{ 'z-index': idx }">
            <component :is="modal.type" :data="modal.data" v-on:closeModal="close(modal)"></component>
        </div>
    </div>
</template>

<script>
/**
 * 页面Store需引用modalStateModule模块
 */
import MessageModal from "./MessageModal";
import ImageClipModal from "../imageUpload/ImageClipModal";
import LinkedQuestionModal from "./LinkedQuestionModal";
import BatchLinkedQuesModal from "./similarQuestion/BatchLinkedQuesModal";
import PictureEditModel from "@/views/zhiji/pages/picture/components/PictureEditModel";
import ReferenceMaterialModal from "../questionEdit/modals/ReferenceMaterialModal";
import TextGuidesEditModel from "@/views/zhiji/pages/guides/components/TextGuidesEditModel";
import ImageViewModal from "@/views/zhiji/components/questionEdit/modals/ImageViewModal";
import VideoEditModel from "@/views/zhiji/pages/video/components/VideoEditModel";
import VideoViewModal from "@/views/zhiji/components/questionEdit/modals/VideoViewModal";
import GuidesViewModal from "@/views/zhiji/components/questionEdit/modals/GuidesViewModal";
import ExportFaqModal from "@/views/zhiji/pages/knowlege/components/ExportFaqModal";
import CorrelateSimilarQuesModal from "./similarQuestion/CorrelateSimilarQuesModal";
import QuestionSelectorTableModal from "./similarQuestion/QuestionSelectorTableModal";
import LinkWordEditModal from "./LinkWordEdit.vue";

export default {
    name: "Modal",
    components: {
        MessageModal,
        ImageClipModal,
        LinkedQuestionModal,
        BatchLinkedQuesModal,
        PictureEditModel,
        ReferenceMaterialModal,
        TextGuidesEditModel,
        ImageViewModal,
        VideoEditModel,
        VideoViewModal,
        GuidesViewModal,
        ExportFaqModal,
        CorrelateSimilarQuesModal,
        QuestionSelectorTableModal,
        LinkWordEditModal,
    },
    computed: {
        isShow() {
            return this.modals.length > 0;
        },
        modals() {
            return this.$store.state.zhiji.modalState.modals;
        }
    },
    methods: {
        close(modal) {
            this.$store.dispatch("zhiji/hideModal", modal.type);
        }
    }
};
</script>

<style lang="less" scoped>
.modal-mask {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    overflow: auto;

    .modal-level {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        min-width: 1200px;
    }
}
</style>
